import ApiRequest from "@/helpers/ApiRequest";
import GetHeaders from "../../helpers/GetHeaders";
import { SAVE_AUTH_USER_INFO, UPDATE_TOKEN, SAVE_PASS_STATUS } from "@/store/mutation-types";

export default {
  actions: {
    saveAuthenticatedUserInfo: ({ commit }, payload) => {
      if(payload.pSts){
        commit(SAVE_PASS_STATUS, payload.pSts);
      }
      commit(SAVE_AUTH_USER_INFO, payload);
    },
    updateAuthenticatedUserInfo: ({ commit }) => {
      commit(UPDATE_TOKEN);
    },
    savePasswordStatus: ({ commit }, payload) => {
      commit(SAVE_PASS_STATUS, payload);
    },
    logIn: async () => {
      
    },
    logOut: async ({commit}) => {
      commit(SAVE_AUTH_USER_INFO, null);
    },
    userSession: async() => {
      return ApiRequest.exploreGet('user_session',
      GetHeaders.projectHeaders()
      ).then(response => {
        console.log(response.data);
        return response.data
      })
    },
    passEmail: async (_, payload) => {
      //return ApiRequest.customPost(
      //  "https://api.emailjs.com/api/v1.0/email/send", payload)
      return ApiRequest.explorePost('email',
      payload,
      GetHeaders.projectHeaders()
      ).then(res => {
        console.log(res)
        return res;
      });
    },
    updatePass: async (_, payload) => {
      return ApiRequest.explorePost('userpassword',
      payload,
      GetHeaders.projectHeaders()
      ).then(response => {
        console.log(response.data);
        return response.data
      })
    },
    updateUserRole: async (_, payload) => {
      return ApiRequest.explorePut('update_user_role',
      {role: payload},
      GetHeaders.dataHeaders()
      ).then(response => {
        console.log(response.data);
        return response.data
      })
    }
  },
  getters: {
    authenticatedUser: state => state.user,
    authenticatedUserBaseRole: state => state.user.role,
    authenticatedUserId: state => (state.user ? state.user._id : null),
    isAuthenticatedUserHasAccess: state => state.userRole === 'discover'? false:true,
    authenticatedUserName: state => (state.user ? state.user.username : null),
    authenticatedUserFullName: state =>
      state.user ? state.user.username : null
  },
  mutations: {
    [SAVE_AUTH_USER_INFO](state, payload) {
      if(!payload){
        state.user = payload;
        state.userRole = null;
        state.userModels = [];
        state.token = null;
        state.tokenAccess = null;
        state.tokenRefresh = null;
      }
      else{
        localStorage.setItem("userRole", payload.role === "discover" ? "discover" : localStorage.getItem("userRole") ? localStorage.getItem("userRole") : "normal");
        state.user = payload;
        state.userRole = localStorage.getItem("userRole")? localStorage.getItem("userRole") : payload.role || null;
        state.userModels = payload.models || [];
        state.token = localStorage.getItem("jwt") || null;
        state.tokenAccess = localStorage.getItem("jwt") || null;
        state.tokenRefresh = localStorage.getItem("jwt") || null;
      }
    },
    [UPDATE_TOKEN](state) {
      state.token = localStorage.getItem("jwt") || null;
      state.tokenAccess = localStorage.getItem("jwt") || null;
      state.tokenRefresh = localStorage.getItem("jwt") || null;
    },
    [SAVE_PASS_STATUS](state, payload) {
      state.passStatus = payload;
    }
  },
  state: {
    token: null,
    user: null,
    userRole: null,
    userModels: null,
    tokenAccess: null,
    tokenRefresh: null,
    passStatus: null
  }
};
